/**
 * This is the start of your custom scripts.
 *
 * While this is currently just a single file you should not add custom scripts in here if you don't have to.
 * Instead create a folder/file structure suitable to the project and import those files in here.
 *
 */

/*
 * === How do I extend on the scripts ===
 *
 * EXAMPLE BELOW
 * If you want to add a new slider script this is how it could look like.

    Example file:
 		src/javascript/component/slickslider.js

 		In main.js:
 		@import './components/slickslider';
 */

import './components/recipe';
import './components/general';
import './components/sliders';
import './components/qr-generator-for-ar';
import './components/qrcode';
import './components/portal';

// import './components/mobile-menu';
// import './components/quantity';
import './components/social';
import './components/parallax';
// import './components/buy-now-popup';
// import './components/quick-view';
import './components/hero-video';
// import './components/image-with-front-text-block';
import './dealers/index';
import './modules/maps';

import IframeTitleChecker from './components/iframes';
new IframeTitleChecker();

import Accordions from './components/accordions';
new Accordions();
